import React from "react";
import {makeStyles} from "@material-ui/core";
import GridBlock from "components/GridBlock";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import PropTypes from "prop-types";
import {OfferEspdType, OfferEspdTypeLabel} from "./constants/OfferEspdType";
import clsx from "clsx";
import Tr from "translations/Translations";
import HelpTooltip from "components/HelpTooltip";

const useStyles = makeStyles(theme => ({
    root: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    button: {
        width: 560,
    },
    help: {
        position: 'absolute',
        right: 70,
        color: theme.palette.text.button
    },
    helpNotSelected: {
        color: theme.palette.primary.main
    }
}));

function OfferEspdTypeSwitch(
    {
        espdType,
        setEspdType,
        disabled
    }) {

    const classes = useStyles();

    const onChange = (event, newEspdProcedure) => {
        if (newEspdProcedure)
            setEspdType(newEspdProcedure);
    };

    return (<GridBlock justify="center" className={classes.root}>
                <ToggleButtonGroup size="medium" value={espdType} exclusive onChange={onChange}>
                    <ToggleButton classes={{root: classes.button}} value={OfferEspdType.INTERNAL} disabled={disabled}>
                        {OfferEspdTypeLabel(OfferEspdType.INTERNAL)}
                        <HelpTooltip className={clsx(classes.help, {[classes.helpNotSelected]: espdType !== OfferEspdType.INTERNAL})}
                                     text={Tr('offer_espd_type_internal_help')}/>
                    </ToggleButton>
                    <ToggleButton classes={{root: classes.button}} value={OfferEspdType.EXTERNAL} disabled={disabled}>
                        {OfferEspdTypeLabel(OfferEspdType.EXTERNAL)}
                        <HelpTooltip className={clsx(classes.help, {[classes.helpNotSelected]: espdType !== OfferEspdType.EXTERNAL})}
                                     text={Tr('offer_espd_type_external_help')}/>
                    </ToggleButton>
                </ToggleButtonGroup>
            </GridBlock>
    )
}

OfferEspdTypeSwitch.propTypes = {
    espdType: PropTypes.string.isRequired,
    setEspdType: PropTypes.func.isRequired,
    disabled: PropTypes.bool
}

export default OfferEspdTypeSwitch;

